module.exports = __webpack_public_path__ + "img/Energetic Driver.bf7bd705.png";